/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIBill
 */
export interface APIBill {
    /**
     * 
     * @type {string}
     * @memberof APIBill
     */
    readonly self: string;
    /**
     * 
     * @type {string}
     * @memberof APIBill
     */
    contract: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIBill
     */
    editors?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APIBill
     */
    readonly files: string;
    /**
     * 
     * @type {Date}
     * @memberof APIBill
     */
    dueDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof APIBill
     */
    amount: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIBill
     */
    paid?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof APIBill
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {boolean}
     * @memberof APIBill
     */
    readonly read: boolean;
}

/**
 * Check if a given object implements the APIBill interface.
 */
export function instanceOfAPIBill(value: object): value is APIBill {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('contract' in value) || value['contract'] === undefined) return false;
    if (!('files' in value) || value['files'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('read' in value) || value['read'] === undefined) return false;
    return true;
}

export function APIBillFromJSON(json: any): APIBill {
    return APIBillFromJSONTyped(json, false);
}

export function APIBillFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIBill {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'contract': json['contract'],
        'editors': json['editors'] == null ? undefined : json['editors'],
        'files': json['files'],
        'dueDate': json['due_date'] == null ? undefined : (new Date(json['due_date'])),
        'amount': json['amount'],
        'paid': json['paid'] == null ? undefined : json['paid'],
        'createdAt': (new Date(json['created_at'])),
        'read': json['read'],
    };
}

export function APIBillToJSON(value?: Omit<APIBill, 'self'|'files'|'created_at'|'read'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'contract': value['contract'],
        'editors': value['editors'],
        'due_date': value['dueDate'] == null ? undefined : ((value['dueDate']).toISOString()),
        'amount': value['amount'],
        'paid': value['paid'],
    };
}

